import styled from 'styled-components';
import { neutralWhite } from '../themes/colors';

export const OnboardingWizardRoot = styled.div`
	display: flex;
	flex-direction: row;
	border-radius: 4px;
	overflow: hidden;
	background: ${neutralWhite};
	box-shadow: 0 2px 5px 0 rgba(32, 56, 87, 0.08);
	font-family: "Red Hat Display", sans-serif;
`;

export const OnboardingWizardSidebar = styled.div`
	padding: 16px;
	border-right: 1px solid ${({ theme }) => theme.form.input.border};
	min-width: 180px;
`;

export const OnboardingWizardContent = styled.div`
	flex: 1;
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const OnboardingWizardContentHeader = styled.h3`
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	line-height: 140%;
`;

export const OnboardingWizardContentBody = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;

	p {
		flex: 1;
		margin: 0;
		font-size: 14px;
		line-height: 1.5;
	}
`;
